import { Button } from 'reactstrap'
import Description from './Description'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import EditDeleteButtonsContainer from 'components/Custom/EditDeleteButtonsContainer'

const List = (props) => {
  let language = props.language || {}

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className=''>
          <div className='quiz-row-wrapper'>
            <button onClick={props.addSection} className='btn btn-info py-2'>
              {language.courses ? language.courses.add_section : null}
            </button>
          </div>
        </div>
      </div>
      <Description {...props} />
      <div className='row-narrow'>
        {props.checklist &&
          props.checklist.sections &&
          props.checklist.sections.length &&
          props.checklist.sections.map((item, index) => (
            <div className='col-md-12 question-item-row mb-2' key={item.id}>
              <div className='row'>
                <div key={index} className='col-11 question-item-title'>
                  {item.name}
                </div>
                <EditDeleteButtonsContainer>
                  <Button
                    outline
                    size='sm'
                    color='light'
                    onClick={() => props.editSection(index)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>
                  <Button
                    outline
                    size='sm'
                    color='danger'
                    onClick={() => props.deleteSection(index)}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </Button>
                </EditDeleteButtonsContainer>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}
export default List
